import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';
import {BigFetchWithCleanPosition, FetchPositionClean} from './fetch-box.model';
import {MergedFrame} from '../../models/frame.models';

@Component({
    selector: 'tr[fetch-box-position]',
    templateUrl: './fetch-box-position.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FetchBoxPositionComponent {
  @Input('fetch-box-position') pos: FetchPositionClean;
  @Input('fetch-box-position-has-price-increase') hasPriceIncrease: boolean;
  @Input('fetch-box-position-fetch') fetch: BigFetchWithCleanPosition;
  @Input('fetch-box-position-frame') frame: MergedFrame;
  @Output('fetch-box-position-reload-fetches') reloadFetches: EventEmitter<void> = new EventEmitter<void>();

  constructor() {
  }
}
